<template>
    <g-form @submit.prevent="handleSubmit">
        <g-loader v-if="isLoading" />
        <div v-else>
            <g-typography tag="p" class="g-mb-6" :value="CONTENT_METRIC_MANUAL_DISPLAY_TEXT" />

            <g-row v-for="fieldName in getManualStatFields(content)" :key="fieldName" type="flex" :gutter="16">
                <g-column :xs="24" :sm="8">
                    <g-typography font-weight="semibold" :value="getMetricFieldLabel(fieldName)" />
                </g-column>
                <g-column :xs="24" :sm="16">
                    <g-form-item class="g-w-full g-mb-0">
                        <g-input
                            :value="getMetricFieldValue(fieldName, manualStatInput)"
                            :disabled="isFieldDisabled(fieldName)"
                            :placeholder="getPlaceholder(fieldName)"
                            @change="(e) => handleFieldChange(fieldName, e)"
                        />
                    </g-form-item>
                </g-column>
            </g-row>

            <g-button
                shape="round"
                theme="live"
                block
                type="primary"
                html-type="submit"
                size="large"
                class="g-mt-6"
                :loading="isSubmitting"
                :disabled="isLoading || isSubmitting"
            >
                Submit Metrics
            </g-button>
        </div>
    </g-form>
</template>

<script>
    import { ref, toRefs } from 'vue-demi';
    import { CONTENT_METRIC_MANUAL_DISPLAY_TEXT } from '../../../../../constants/activation-content-metrics';
    import useContentMetrics from '../../../../../../src/composables/use-content-metrics';

    export default {
        name: 'ActivationContentMetricsManual',
        props: {
            content: {
                type: Object,
                default: null,
                required: true
            },
            isSubmitting: {
                type: Boolean,
                default: false
            },
            isLoading: {
                type: Boolean,
                default: false
            }
        },

        setup(props, { emit }) {
            const {
                getMetricFieldLabel,
                getMetricFieldValue,
                setMetricFieldValue,
                getMetricRealFieldValue,
                hasMetricRealFieldValue,
                getManualStatFields,
                setManualStatInput
            } = useContentMetrics();
            const { content, isSubmitting, isLoading } = toRefs(props);

            const manualStatInput = ref({
                impressions: null,
                comments: null,
                likes: null,
                saves: null,
                shares: null,
                reach: null,
                views: null,
                replies: null
            });

            manualStatInput.value = setManualStatInput(content.value, manualStatInput.value);

            const isFieldDisabled = (fieldName) => {
                return isLoading.value || isSubmitting.value || hasMetricRealFieldValue(fieldName, content.value);
            };

            const getPlaceholder = (fieldName) => {
                return isFieldDisabled(fieldName) ? getMetricRealFieldValue(fieldName, content.value) : '';
            };

            const handleFieldChange = (name, value) => {
                manualStatInput.value = setMetricFieldValue(name, manualStatInput.value, value);
            };

            const handleSubmit = () => {
                emit('update-content-metrics', content.value.id, manualStatInput.value);
            };

            return {
                CONTENT_METRIC_MANUAL_DISPLAY_TEXT,
                manualStatInput,
                isFieldDisabled,
                getPlaceholder,
                getMetricFieldLabel,
                getMetricFieldValue,
                getManualStatFields,
                getMetricRealFieldValue,
                handleFieldChange,
                handleSubmit
            };
        }
    };
</script>
